import React from "react"
import Button from "../button/Button.js"

const Personal = ({ closePersonal, setChecked }) => {
  React.useEffect(() => {
    document.body.style.overflow = "hidden"
    return () => (document.body.style.overflow = "")
  }, [])

  return (
    <div onClick={closePersonal} className="personal-data">
      <div className="personal__container">
        <div onClick={(e) => e.stopPropagation()} className="personal__agreement">
          <h2 className="personal__title">Соглашение о защите персональных данных пользователя</h2>
          <div className="personal__head">
            <h3 className="personal__preamble">ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</h3>
            <p className="personal__paragraph">
              Настоящая Политика конфиденциальности определяет политику &nbsp;
              <strong>Frontier</strong>, расположенной по адресу: г. Санкт-Петербург, Невский пр-кт, 71 (5 этаж) (далее – Администрация Сайта), в
              отношении обработки персональных данных и содержит сведения о реализуемых требованиях к защите персональных данных физических лиц,
              пользующихся услугами интернет-сайта http://frontiers.ru/ (далее – Сайт) и его сервисов (далее – Пользователи).
            </p>
          </div>
          <div className="personal__basic">
            <h5 className="personal__subtitle">Основные понятия</h5>
            <p className="personal__paragraph">
              персональные данные - любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу;
            </p>
            <p className="personal__paragraph">
              обработка персональных данных - любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств
              автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение,
              уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание,
              блокирование, удаление, уничтожение персональных данных.
            </p>
            <h5 className="personal__subtitle">Предоставление персональных данных</h5>
            <p className="personal__paragraph">
              Предоставляя нам свои персональные данные при использовании Сайта, Вы даете согласие на обработку Ваших персональных данных в
              соответствии с данной Политикой конфиденциальности.
            </p>
            <dl>
              <dt className="personal__paragraph">В частности, дачей согласия на обработку Ваших персональных данных является:</dt>
              <dd className="personal__paragraph">
                · регистрация на Сайте посредством заполнения регистрационной формы с указанием необходимой и, при желании, дополнительной информации,
                предусмотренной формой;
              </dd>
              <dd className="personal__paragraph">
                · подписка на Сайте на рассылку новостных и информационных материалов посредством заполнения формы с указанием необходимой информации,
                предусмотренной формой;
              </dd>
              <dd className="personal__paragraph">
                · оформление на Сайте заявки на получение услуг с указанием необходимой информации, предусмотренной формой заявки;
              </dd>
              <dd className="personal__paragraph">
                · предоставление персональных данных посредством заполнения иных информационных полей на Сайте (при наличии);
              </dd>
              <dd className="personal__paragraph">
                · предоставление персональных данных путем отправки электронных сообщений в адрес Администрации Сайта.
              </dd>
            </dl>
            <p className="personal__paragraph">
              Подписка на Сайте на рассылку новостных и информационных материалов посредством заполнения соответствующей формы является согласием
              Пользователя на получение от Администрации Сайта сообщений рекламно-информационного характера. Если Пользователь не желает получать
              рассылки от Администрации Сайта, он вправе отписаться от рассылки Администрации Сайта.
            </p>
            <p className="personal__paragraph">
              Администрация Сайта обязуется не раскрывать третьим лицам и не распространять персональные данные без согласия Пользователя, если иное
              не предусмотрено федеральным законом.
            </p>
            <p className="personal__paragraph">
              Пользователь вправе отозвать согласие на обработку своих персональных данных, предоставленных Администрации Сайта. Для этого необходимо
              отправить соответствующее уведомление на адрес: nk@frontiers.ru
            </p>
            <h5 className="personal__subtitle">Цели сбора и обработки персональных данных</h5>
            <dl>
              <dt className="personal__paragraph">
                Администрация Сайта обрабатывает Ваши персональные данные в целях, для которых они были предоставлены, в том числе:
              </dt>
              <dd className="personal__paragraph">· для регистрации запроса Пользователя на Сайте;</dd>
              <dd className="personal__paragraph">
                · для регистрации Пользователя на Сайте для предоставления расширенного доступа к функционалу Сайта;
              </dd>
              <dd className="personal__paragraph">
                · для направления Пользователю наших новостных и (или) информационных материалов, в т.ч. информации об Администрации Сайта, наших
                услугах, мероприятиях;
              </dd>
              <dd className="personal__paragraph">· для ответа на вопросы и иные обращения Пользователей;</dd>
              <dd className="personal__paragraph">· для рассмотрения запроса о предоставлении услуг Пользователю;</dd>
              <dd className="personal__paragraph">· для рассмотрения запроса о предоставлении услуг Пользователю;</dd>
              <dd className="personal__paragraph">
                · для выполнения обязанностей, установленных для Администрации Сайта законодательством Российской Федерации;
              </dd>
              <dd className="personal__paragraph">· для других целей с согласия Пользователя.</dd>
            </dl>
            <h5 className="personal__subtitle">Защита персональных данных</h5>
            <p className="personal__paragraph">
              Администрация Сайта принимает необходимые правовые, организационные и технические меры для защиты персональных данных Пользователей от
              неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования, предоставления, распространения
              персональных данных, а также от иных неправомерных действий в отношении персональных данных.
            </p>
            <p className="personal__paragraph">
              Администрация Сайта ограничивает внутренний доступ к персональным данным Пользователей исключительно сотрудниками, которым это
              необходимо для выполнения своих служебных обязанностей, с предварительным ознакомлением таких сотрудников с настоящей Политикой
              конфиденциальности, а также нормативно-методическими документами по защите информации.
            </p>
            <p className="personal__paragraph">При работе с персональными данными исключается бесконтрольное использование защищаемой информации.</p>
            <p className="personal__paragraph">
              Внешний доступ к персональным данным Пользователей ограничивается исключительно лицами (органами) и случаями, предусмотренными
              законодательством Российской Федерации.
            </p>
            <p className="personal__paragraph">
              Администрация Сайта принимает локальные акты по вопросам безопасности персональных данных и назначает лицо, ответственное за организацию
              обработки персональных данных.
            </p>
            <p className="personal__paragraph">
              Администрация Сайта определяет угрозы безопасности персональных данных при их обработке в информационных системах персональных данных,
              учитывает и обеспечивает сохранность машинных и иных носителей персональных данных, применяет прошедшие в установленном порядке
              процедуру оценки соответствия средства защиты информации, обеспечивает контроль за действиями, совершаемыми с персональными данными в
              информационной системе персональных данных.
            </p>
            <h5 className="personal__subtitle">Хранение персональных данных</h5>
            <p className="personal__paragraph">
              Хранение персональных данных Пользователей осуществляется Администрацией Сайта в форме, позволяющей определить субъекта персональных
              данных, не дольше, чем этого требуют цели обработки персональных данных, если иной срок хранения персональных данных не установлен
              федеральным законом, договором, стороной которого, выгодоприобретателем или поручителем по которому является Пользователь, либо
              Пользователем при даче согласия на обработку персональных данных. Обрабатываемые персональные данные подлежат уничтожению либо
              обезличиванию по достижении целей обработки или в случае утраты необходимости в достижении этих целей, если иное не предусмотрено
              федеральным законом.
            </p>
            <h5 className="personal__subtitle">Прекращение обработки персональных данных</h5>
            <p className="personal__paragraph">
              Администрация Сайта прекращает обработку и уничтожает персональные данные в случае достижения цели обработки персональных данных или
              отзыва Пользователем согласия на обработку его персональных данных, если иное не предусмотрено договором, стороной которого,
              выгодоприобретателем или поручителем по которому является Пользователь, иным соглашением между Администрацией Сайта и Пользователем.
            </p>
            <p className="personal__paragraph">
              Администрация Сайта прекращает обработку персональных данных также при наступлении условий прекращения обработки персональных данных; в
              случае выявления неправомерной обработки персональных данных, если обеспечить правомерность обработки невозможно; по истечении срока
              действия согласия Пользователя на обработку персональных данных; в случае ликвидации Администрации Сайта; в иных случаях,
              предусмотренных законом.
            </p>
          </div>
          <div onClick={closePersonal}>
            <div onClick={setChecked}>
              <Button title="принять" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Personal
